export class PsResourceDocumentSchema {

    _id; // number
    _description; // string

    constructor(
        id,
        description,
    ) {
        this._id = id;
        this._description = description;
    }

    static null() {
        return new this(
            -1,
            '',
        );
    }

    static fromAPIDocumentSchema(schema) {
        return new this(
            schema.id,
            schema.name,
        );
    }

    id() {
        return this._id;
    }

    description() {
        return this._description;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/resource/PsResourceDocumentSchema.js